function cubicIn(t) {
  return t * t * t
}

module.exports = cubicIn


//////////////////
// WEBPACK FOOTER
// ./~/eases/cubic-in.js
// module id = 129
// module chunks = 35783957827783 255223432971881